import { styled, Box } from '@mui/material';

export const TimePickerStyled = styled(Box)(() => ({
  position: 'relative',
}));
